/*!
 * ScrollTrigger Animation Library - JavaScript
 * Lightweight scroll-triggered animations for website builders
 * Uses IntersectionObserver API for performance
 * Size: ~6KB minified
 * Version: 1.0.0
 */
(function() {
    "use strict";
    const config = {
        threshold: .1,
        rootMargin: "0px 0px -50px 0px",
        triggerClass: "triggered"
    }
      , animationClasses = ["fade-in", "slide-up", "slide-down", "slide-left", "slide-right", "zoom-in", "zoom-out", "scale-up", "rotate-in", "bounce-in", "showsolitext", "image-animation"];
    let observer = null;
    const triggeredElements = new WeakSet;
    function init() {
        window.matchMedia("(prefers-reduced-motion: reduce)").matches && !window.forceScrollTrigger || (observer = new IntersectionObserver(handleIntersection,{
            threshold: config.threshold,
            rootMargin: config.rootMargin
        }),
        observeElements(),
        setupMutationObserver())
    }
    function handleIntersection(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const element = entry.target;
                let totalDelay = 0;
                const customDelay = parseFloat(element.dataset.delay) * 1e3 || 0
                  , staggerDelay = parseInt(element.dataset.staggerDelay) || 0;
                totalDelay = customDelay + staggerDelay,
                setTimeout( () => {
                    triggerElement(element)
                }
                , totalDelay),
                element.classList.contains("trigger-once") && observer.unobserve(element)
            }
        }
        )
    }
    function triggerElement(element) {
        element.classList.add(config.triggerClass),
        triggeredElements.add(element),
        element.dispatchEvent(new CustomEvent("scrolltrigger:triggered",{
            detail: {
                element
            }
        }))
    }
    function observeElements() {
        const selector = animationClasses.map(cls => `.${cls}`).join(", ");
        document.querySelectorAll(selector).forEach(element => {
            if (triggeredElements.has(element) && element.classList.contains("trigger-once"))
                return;
            const staggerContainer = element.closest(".stagger-children");
            staggerContainer && setupStaggerElement(element, staggerContainer),
            observer.observe(element)
        }
        )
    }
    function setupStaggerElement(element, container) {
        if (element.closest(".text-blurbs-swiper") || element.classList.contains("swiper-animation"))
            return;
        const staggerSelector = animationClasses.map(cls => `.${cls}`).join(", ")
          , elementIndex = Array.from(container.querySelectorAll(staggerSelector)).filter(el => !el.closest(".text-blurbs-swiper") && !el.classList.contains("swiper-animation")).indexOf(element);
        if (elementIndex !== -1) {
            const customDelay = parseInt(container.dataset.staggerDelay) || 120
              , staggerDelay = elementIndex * customDelay;
            element.dataset.staggerDelay = staggerDelay.toString(),
            element.classList.add("stagger-item")
        }
    }
    function setupMutationObserver() {
        new MutationObserver(mutations => {
            let shouldUpdate = !1;
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        const hasAnimClass = animationClasses.some(cls => node.classList && node.classList.contains(cls))
                          , hasAnimChildren = node.querySelectorAll && animationClasses.some(cls => node.querySelectorAll(`.${cls}`).length > 0);
                        (hasAnimClass || hasAnimChildren) && (shouldUpdate = !0)
                    }
                }
                )
            }
            ),
            shouldUpdate && setTimeout(observeElements, 100)
        }
        ).observe(document.body, {
            childList: !0,
            subtree: !0
        })
    }
    const ScrollTrigger = {
        trigger: function(selector) {
            (typeof selector == "string" ? document.querySelectorAll(selector) : [selector]).forEach(triggerElement)
        },
        reset: function(selector) {
            (typeof selector == "string" ? document.querySelectorAll(selector) : [selector]).forEach(element => {
                element.classList.remove(config.triggerClass),
                triggeredElements.delete(element),
                observer && observer.observe(element)
            }
            )
        },
        refresh: function() {
            observeElements()
        },
        destroy: function() {
            observer && (observer.disconnect(),
            observer = null)
        },
        version: "1.0.0"
    };
    document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", init) : init(),
    window.ScrollTrigger = ScrollTrigger,
    typeof module < "u" && module.exports && (module.exports = ScrollTrigger)
}
)();